import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.625 9C19.3021 9 19.888 8.99739 20.3828 9.49219C20.8776 9.98698 21 10.5729 21 11.25V16H18V21H6V16H3V11.25C3 10.5729 3.12239 9.98698 3.61719 9.49219C4.11198 8.99739 4.69791 9 5.375 9H18.625ZM16.0029 19L16 13H8V19H16.0029ZM18 4V8H6V4H18Z" fill="currentColor" />
        </svg>

    );
};

export default React.memo(Print);
